<div class="input-wrapper" [class.active]="hasFocusTitle || hasValue(s.value)" [class.hasvalue]="!hasFocusTitle && hasValue(s.value)">
    <div class="wrapper-inner">
        <div class="inner-content">
            <label _ngcontent-kfe-c105="" tabindex="-1" class="hidden" for="autoCompleteSearchHEADER">Suche</label>
            <input
                id="title"
                type="text"
                #s="ngModel"
                [(ngModel)]="title"
                (keyup.enter)="enterPressed($event)"
                [placeholder]="'courses.searchByTitle' | translate"
                (keyup)="searchListSuggestions($event.target.value)"
                (keydown)="listFocus($event)"
                tabindex="0"
            />

            <ng-container *ngIf="showResults$ | async as results">
                <div
                    class="dropdown"
                    id="searchList"
                    *ngIf="hasFocusTitle && results && results.length > 0"
                    (keydown)="listFocusNext($event)"
                >
                    <div *ngFor="let result of results; let i = index" tabindex="0">
                        <a
                            class="search-element"
                            id="element{{ i }}"
                            href="javascript:;"
                            (click)="clickLink(result.id, result.name)"
                            (keyup.enter)="valuechange($event.result.name)"
                        >
                            <span [innerHTML]="getHighlightedString(result.name, title)"></span>
                        </a>
                    </div>
                </div>
            </ng-container>
        </div>
        <button type="button" [class.active]="title" class="reset" tabindex="0" role="button" (click)="resetTitle()"></button>
    </div>
    <button type="button" class="" (click)="valuechange(title)" tabindex="0" role="button"></button>
</div>
